'use strict';

var transformDateTimePartNumberToStringWithZeroPadding = require('../common/transformDateTimePartNumberToStringWithZeroPadding.cjs');

const assembleISOTimePartToParts = (timeParts) => {
  return [timeParts.hour, timeParts.minute, timeParts.second].map((part) => transformDateTimePartNumberToStringWithZeroPadding(part)).join(":");
};

module.exports = assembleISOTimePartToParts;
//# sourceMappingURL=assemblePartsToISOTimePart.cjs.map
